// Version : 0.0.1
// Author : VISHNU
// LastEdit : KARTHEESWARAN
//Last ADD : ALL PAYLOAD DATA FETCHED IN SINGLE LINE
// MODFIED DATE:31-07-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addInsuranceCompanyDetailsFailure,
	addInsuranceCompanyDetailsResponseChanged,
	addInsuranceCompanyDetailsSuccess,
	deleteInsuranceCompanyDetailsFailure,
	deleteInsuranceCompanyDetailsResponseChanged,
	deleteInsuranceCompanyDetailsSuccess,
	fetchAllInsuranceCompanyFailure,
	fetchAllInsuranceCompanyResponseChanged,
	fetchAllInsuranceCompanySuccess,
	fetchInsuranceCompanyDetailsFailure,
	fetchInsuranceCompanyDetailsResponseChanged,
	fetchInsuranceCompanyDetailsSuccess,
	getInsuranceCompanyListFailure,
	getInsuranceCompanyListResponseChanged,
	getInsuranceCompanyListSuccess,
	updateInsuranceCompanyDetailsFailure,
	updateInsuranceCompanyDetailsResponseChanged,
	updateInsuranceCompanyDetailsSuccess,
} from './insurance-company.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import insuranceCompanyActionTypes from './insurance-company.types';
import {
	allInsuranceCompanyFetch,
	insuranceCompanyDetailsAdd,
	insuranceCompanyDetailsDelete,
	insuranceCompanyDetailsFetch,
	insuranceCompanyDetailsUpdate,
	insuranceCompanyListGet,
} from './insurance-company.services';

/** *********************  START ADD INSURANCE COMPANY DETAILS  ******************** */
export function* createInsuranceCompany({ payload }: any) {
	try {
		const {
			insuranceCompanyName,
			contactPersonName1,
			address1,
			phoneNumber1,
			contactPersonName2,
			address2,
			phoneNumber2,
			contactPersonName3,
			address3,
			phoneNumber3,
			gst,
			pan,
			state,
			district,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
			pincode,
		} = payload;
		const key = 'AddInsuranceCompanyDetailKey';
		const jsonData = {
			InsuranceCompanyName: insuranceCompanyName,
			ContactPersonName1: contactPersonName1,
			Address1: address1,
			PhoneNumber1: phoneNumber1,
			ContactPersonName2: contactPersonName2,
			Address2: address2,
			PhoneNumber2: phoneNumber2,
			ContactPersonName3: contactPersonName3,
			Address3: address3,
			PhoneNumber3: phoneNumber3,
			GST: gst,
			PAN: pan,
			State: state,
			District: district,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			Pincode: pincode,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(insuranceCompanyDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addInsuranceCompanyDetailsFailure(responseData.data));
		} else {
			yield put(addInsuranceCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addInsuranceCompanyDetailsFailure(error));
	}
}

export function* resetAddInsuranceCompanyResponse() {
	yield put(addInsuranceCompanyDetailsResponseChanged());
}

export function* onCreateInsuranceCompanyDetails() {
	yield takeLatest(
		insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_START,
		createInsuranceCompany,
	);
}

export function* onCreateInsuranceCompanyResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
		resetAddInsuranceCompanyResponse,
	);
}
/** *********************  END ADD INSURANCE COMPANY DETAILS ******************** */

/*************** START UPDATE INSURANCE COMPANY DETAILS ******************/
export function* insuranceCompanyUpdate({ payload }: any) {
	try {
		const {
			insuranceCompanyID,
			insuranceCompanyName,
			contactPersonName1,
			address1,
			phoneNumber1,
			contactPersonName2,
			address2,
			phoneNumber2,
			contactPersonName3,
			address3,
			phoneNumber3,
			gst,
			pan,
			state,
			district,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
			pincode,
		} = payload;
		const key = 'UpdateInsuranceCompanyDetailsKey';
		const jsonData = {
			InsuranceCompanyID: insuranceCompanyID,
			InsuranceCompanyName: insuranceCompanyName,
			ContactPersonName1: contactPersonName1,
			Address1: address1,
			PhoneNumber1: phoneNumber1,
			ContactPersonName2: contactPersonName2,
			Address2: address2,
			PhoneNumber2: phoneNumber2,
			ContactPersonName3: contactPersonName3,
			Address3: address3,
			PhoneNumber3: phoneNumber3,
			GST: gst,
			PAN: pan,
			State: state,
			District: district,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			Pincode: pincode,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(insuranceCompanyDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateInsuranceCompanyDetailsFailure(responseData.data));
		} else {
			yield put(updateInsuranceCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateInsuranceCompanyDetailsFailure(error));
	}
}

export function* resetUpdateInsuranceCompanyDetailsResponse() {
	yield put(updateInsuranceCompanyDetailsResponseChanged());
}

export function* onUpdateInsuranceCompanyDetails() {
	yield takeLatest(
		insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_START,
		insuranceCompanyUpdate,
	);
}

export function* onUpdateInsuranceCompanyResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
		resetUpdateInsuranceCompanyDetailsResponse,
	);
}
/*************** END UPDATE INSURANCE COMPANY DETAILS ******************/

/*************** START GET INSURANCE COMPANY LIST ******************/
export function* insuranceCompanyDetailsListGet({ payload }: any) {
	try {
		const { companyID, inputSearch, limit, databaseName } = payload;
		const key = 'GetInsuranceCompanyListKey';
		const jsonData = {
			CompanyID: companyID,
			SearchData: inputSearch,
			Limit: limit,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(insuranceCompanyListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getInsuranceCompanyListFailure(responseData.data));
		} else {
			yield put(getInsuranceCompanyListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getInsuranceCompanyListFailure(error));
	}
}

export function* resetGetInsuranceCompanyListResponse() {
	yield put(getInsuranceCompanyListResponseChanged());
}

export function* onGetInsuranceCompanyListDetails() {
	yield takeLatest(
		insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_START,
		insuranceCompanyDetailsListGet,
	);
}

export function* onGetInsuranceCompanyListResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_RESPONSE_RESET,
		resetGetInsuranceCompanyListResponse,
	);
}
/*************** END GET INSURANCE COMPANY LIST ******************/

/** *********************  START FETCH INSURANCE COMPANY DETAILS  ******************** */
export function* fetchInsuranceCompanyData({ payload }: any) {
	try {
		const { companyID, insuranceCompanyID, databaseName } = payload;
		const key = 'FetchInsuranceCompanyDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			InsuranceCompanyID: insuranceCompanyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(insuranceCompanyDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchInsuranceCompanyDetailsFailure(responseData.data));
		} else {
			yield put(fetchInsuranceCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchInsuranceCompanyDetailsFailure(error));
	}
}

export function* resetFetchInsuranceCompanyDetailsResponse() {
	yield put(fetchInsuranceCompanyDetailsResponseChanged());
}

export function* onFetchInsuranceCompanyDetails() {
	yield takeLatest(
		insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_START,
		fetchInsuranceCompanyData,
	);
}

export function* onFetchInsuranceCompanyResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
		resetFetchInsuranceCompanyDetailsResponse,
	);
}
/** *********************  END FETCH INSURANCE COMPANY DETAILS ******************** */

/** *********************  START DELETE INSURANCE COMPANY DETAILS  ******************** */
export function* insuranceCompanyDelete({ payload }: any) {
	try {
		const {
			companyID,
			insuranceCompanyID,
			insuranceCompanyName,
			contactPersonName1,
			address,
			phoneNumber,
			contactPersonName2,
			address2,
			phoneNumber2,
			contactPersonName3,
			address3,
			phoneNumber3,
			gst,
			pan,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'DeleteInsuranceCompanyDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			InsuranceCompanyID: insuranceCompanyID,
			InsuranceCompanyName: insuranceCompanyName,
			ContactPersonName1: contactPersonName1,
			Address1: address,
			PhoneNumber1: phoneNumber,
			ContactPersonName2: contactPersonName2,
			Address2: address2,
			PhoneNumber2: phoneNumber2,
			ContactPersonName3: contactPersonName3,
			Address3: address3,
			PhoneNumber3: phoneNumber3,
			GST: gst,
			PAN: pan,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(insuranceCompanyDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteInsuranceCompanyDetailsFailure(responseData.data));
		} else {
			yield put(deleteInsuranceCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteInsuranceCompanyDetailsFailure(error));
	}
}

export function* resetDeleteInsuranceCompanyDetailsResponse() {
	yield put(deleteInsuranceCompanyDetailsResponseChanged());
}

export function* onDeleteInsuranceCompanyDetail() {
	yield takeLatest(
		insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_START,
		insuranceCompanyDelete,
	);
}

export function* onDeleteInsuranceCompanyResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
		resetDeleteInsuranceCompanyDetailsResponse,
	);
}
/** *********************  END DELETE INSURANCE COMPANY DETAILS ******************** */

/** *********************  START FETCH ALL INSURANCE COMPANY LIST  ******************** */
export function* fetchAllInsuranceCompanysList({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			userInsuranceCompany,
			userLevel,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'FetchAllInsuranceCompanyKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserInsuranceCompany: userInsuranceCompany,
			Level: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allInsuranceCompanyFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllInsuranceCompanyFailure(responseData.data));
		} else {
			yield put(fetchAllInsuranceCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllInsuranceCompanyFailure(error));
	}
}

export function* resetFetchAllInsuranceCompanysResponse() {
	yield put(fetchAllInsuranceCompanyResponseChanged());
}

export function* onFetchAllInsuranceCompanysDetails() {
	yield takeLatest(
		insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_START,
		fetchAllInsuranceCompanysList,
	);
}

export function* onFetchAllInsuranceCompanysResponseReset() {
	yield takeLatest(
		insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_RESPONSE_RESET,
		resetFetchAllInsuranceCompanysResponse,
	);
}
/** *********************  END FETCH ALL INSURANCE COMPANY LIST ******************** */

export function* insuranceCompanySaga() {
	yield all([
		call(onCreateInsuranceCompanyDetails),
		call(onCreateInsuranceCompanyResponseReset),
		call(onUpdateInsuranceCompanyDetails),
		call(onUpdateInsuranceCompanyResponseReset),
		call(onGetInsuranceCompanyListDetails),
		call(onGetInsuranceCompanyListResponseReset),
		call(onFetchInsuranceCompanyDetails),
		call(onFetchInsuranceCompanyResponseReset),
		call(onDeleteInsuranceCompanyDetail),
		call(onDeleteInsuranceCompanyResponseReset),
		call(onFetchAllInsuranceCompanysDetails),
		call(onFetchAllInsuranceCompanysResponseReset),
	]);
}
